/**
 * Article Slideshow Functionality.
 */
import $ from 'jquery';
import 'slick-carousel';

const articleSlickSlider = () => {
	const mediaSlideshow = document.querySelectorAll('.article-slideshow');

	mediaSlideshow.forEach((slideshow) => {
		$(slideshow).slick({
			dots: false,
			infinite: true,
			speed: 500,
			adaptiveHeight: true,
		});
	});
	return true;
};

document.addEventListener('DOMContentLoaded', articleSlickSlider);
